import { Editor } from "@tinymce/tinymce-react";
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { UseAuthContext } from "../../store/contexts/auth.context";
import { UsePostsContext } from "../../store/contexts/posts.context";
import Container from "../../UI/Container";
import EditorInit from "../../utils/EditorInit";

function AddPost() {
  const { createPost } = UseAuthContext();
  const [initial, setinitial] = useState();
  const [body, setbody] = useState();
  const { getPost, updatePost, getPostBody } = UsePostsContext();
  const navigate = useNavigate();
  const editorRef = useRef(null);
  const [error, seterror] = useState({
    title: null,
    text: null,
    keywords: null,
  });
  const [searchParams] = useSearchParams();
  const imgEl = useRef();
  const keywords = useRef();
  const title = useRef();
  const [img, setimg] = useState(null);
  const [imgpath, setimgpath] = useState();
  useEffect(() => {
    if (searchParams.get("id")) {
      getPost(searchParams.get("id")).then((res) => {
        setimgpath(res.data.image.String);
        setinitial(res.data);
        title.current.value = res.data.post_title;
        keywords.current.value = res.data.post_tags.join(", ");
      });
      getPostBody(searchParams.get("id")).then((res) => {
        setbody(res.data);
      });
    }
  }, []);
  useEffect(() => {
    if (img) {
      const reader = new FileReader();
      reader.onload = function (e) {
        console.log(e);
        setimgpath(e.target.result);
      };
      reader.readAsDataURL(img);
    }
  }, [img]);
  const submitHandler = async () => {
    const tags = keywords.current.value.split(",").map((i) => i.trim());
    const newData = {
      tags,
      text: editorRef.current?.getContent(),
      title: title.current.value,
    };
    if (searchParams.get("id")) {
      await updatePost(+searchParams.get("id"), newData, {
        img,
        imgpath,
      });
    } else {
      await createPost(newData, img);
    }
    navigate("/posts");
  };
  return (
    <Wrapper>
      <Container>
        <div className="devider"></div>
        <h2 className="main-title">
          <input
            type="text"
            className="title form-input"
            placeholder="Enter post title here..."
            ref={title}
          />
        </h2>
        <div className={`preview-wrapper ${!imgpath ? "none" : ""}`}>
          {imgpath && <img className="previewImg" src={imgpath} ref={imgEl} />}
          <img
            src="https://img.icons8.com/ios-glyphs/60/ffffff/filled-trash.png"
            alt=""
            className="delete"
            onClick={() => {
              setimg(null);
              setimgpath(null);
            }}
          />
        </div>
        <label htmlFor="image" className={`image ${imgpath ? "none" : ""}`}>
          <img src="https://img.icons8.com/external-simple-solid-edt.graphics/50/undefined/external-Plus-add-and-remove-simple-solid-edt.graphics-11.png" />
          Choose Image
        </label>
        <input
          type="file"
          name="image"
          id="image"
          style={{ display: "none" }}
          accept="image/*"
          onChange={(e) => setimg(e.target.files[0])}
        />
        <div className="devider"></div>
        <Editor
          apiKey="kllgkgzl1jf73orrkxvjotylum0176bi0h4tadigk7ul9lbr"
          onInit={(evt, editor) => (editorRef.current = editor)}
          initialValue={body ? body : "Write here..."}
          init={EditorInit}
        />
        <div className="flex between">
          <input
            type="text"
            placeholder="Keywords: Medicine, Doctors, etc..."
            className="form-input"
            ref={keywords}
          />
          <input
            type="button"
            onClick={submitHandler}
            className="form-input"
            value={"Save Now"}
          />
        </div>
        <div className="devider"></div>
      </Container>
    </Wrapper>
  );
}
export default AddPost;

const Wrapper = styled.form`
  .title {
    font-size: 32px;
    background-color: #fff0;
    height: auto;
    @media (max-width: 767px) {
      font-size: 20px;
      padding: 4px 10px;
    }
  }
  .main-title {
    @media (max-width: 767px) {
      padding-left: 10px;
    }
  }
  .flex {
    margin-top: 24px;
    gap: 24px;
    @media (max-width: 767px) {
      flex-direction: column;
      gap: 12px;
    }
  }
  .preview-wrapper {
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    aspect-ratio: 16/6;
    @media (max-width: 767px) {
      aspect-ratio: 16/9;
    }
    .delete {
      position: absolute;
      top: 20px;
      width: 40px;
      right: -50px;
      z-index: 2;
      transition: all 0.3s;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
    }
    &::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: "";
      transition: all 0.5s;
      background: linear-gradient(to right, #0000, #000);
      opacity: 0;
    }
    &:hover {
      .delete {
        right: 20px;
      }
      &::after {
        opacity: 0.8;
      }
    }
    .previewImg {
      width: 100%;
      object-fit: cover;
      height: 100%;
      object-position: center;
    }
  }
  .image {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    aspect-ratio: 16/6;
    border-radius: 8px;
    border: 2px solid #b6b6b6;
    background-color: #e7e7e7;
    transition: all 0.2s;
    &:hover {
      background-color: #d6d6d6;
      cursor: pointer;
    }
  }
`;
